<template>
  <div align="left">
    <b-tabs pills vertical>
      <b-tab title="Arithmetic"><arithmetic/></b-tab>
      <b-tab title="Shifting"><shifting/></b-tab>
      <b-tab title="Boolean"><boolean/></b-tab>
      <b-tab title="Precedence"><precedence/></b-tab>
    </b-tabs>
  </div>
</template>

<script>
import arithmetic from '@/components/arithmetic'
import shifting from '@/components/shifting'
import boolean from '@/components/boolean'
import precedence from '@/components/precedence'

export default {
  name: 'Operators',
  components: {
    arithmetic,
    shifting,
    boolean,
    precedence
  }
}
</script>



// WEBPACK FOOTER //
// src/components/operators.vue